<div class="modal-body p-xl-5 p-4 position-relative text-center">
	<div class="mb-4">
		<h2 class="fw-bold mb-3">Verifica codice</h2>
		<p class="text-muted mb-2">
			@if (mode === 'remote') {
				Inserire il codice OTP generato dal proprio dispositivo:
			} @else {
				Un codice a 6 cifre è stato inviato al numero di cellulare
				<strong>{{ phone }}</strong>
			}
		</p>

		@if (mode === 'sms') {
			<p class="text-muted small mb-0">
				Riferimento operazione:
				<strong>{{ operationRef }}</strong>
			</p>
		}
	</div>

	<div class="mb-2">
		<span class="text-primary fw-bold" style="font-size: 14px;">Codice OTP</span>
	</div>

	<div class="otp-input-container d-flex justify-content-center align-items-center gap-2 mb-4">
		@for (i of [0,1,2]; track i) {
			<input
				type="text"
				inputmode="numeric"
				[maxlength]="i === 0 ? 6 : 1"
				[autocomplete]="i === 0 ? 'one-time-code' : 'off'"
				class="otp-box-modal"
				placeholder="0"
				[id]="'otp-modal-' + i"
				[ngModel]="otpDigits()[i]"
				(input)="onOtpInput(i, $event)"
				(keydown)="onOtpKeydown(i, $event)"
				(paste)="onOtpPaste($event)" />
		}

		<span class="mx-1" style="font-size: 32px; color: #d1d5db; font-weight: 300;">-</span>

		@for (i of [3,4,5]; track i) {
			<input
				type="text"
				inputmode="numeric"
				maxlength="1"
				autocomplete="off"
				class="otp-box-modal"
				placeholder="0"
				[id]="'otp-modal-' + i"
				[ngModel]="otpDigits()[i]"
				(input)="onOtpInput(i, $event)"
				(keydown)="onOtpKeydown(i, $event)"
				(paste)="onOtpPaste($event)" />
		}
	</div>

	@if (mode === 'sms') {
		<div class="text-center mb-4">
			<p class="text-muted small mb-1">Tempo rimasto: {{ timerDisplay() }}</p>
			@if (timerValue() === 0) {
				<a href="javascript:void(0)" class="text-primary fw-bold small text-decoration-none" (click)="requestResend()">Clicca qui per richiedere un nuovo codice OTP</a>
			}
		</div>
	}

	<div class="d-flex flex-column gap-3 align-items-center mt-2">
		<button class="btn btn-kf-primary w-100 py-3 fw-bold shadow-sm" style="text-transform: uppercase; letter-spacing: 1px;" (click)="conferma()" [disabled]="!isOtpComplete()">
			AUTENTICATI
		</button>

		<a href="javascript:void(0)" class="text-primary text-decoration-none fw-bold small d-flex align-items-center gap-2 mt-2" (click)="dismiss()">
			<i class="bi bi-arrow-left"></i>
			Torna alle pratiche da firmare
		</a>
	</div>
</div>
